(function(){
  if (window.__tbx) return; window.__tbx = 1;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;
  var hasIO = 'IntersectionObserver' in window;

  /* reveal */
  var rio = hasIO ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { e.target.classList.add('in'); rio.unobserve(e.target); } });
  }, {threshold: .12, rootMargin: '0px 0px -6% 0px'}) : null;

  /* counters */
  function count(el){
    var to = parseFloat(el.dataset.count), dec = (el.dataset.count.split('.')[1] || '').length, t0 = null, dur = 1800;
    if (reduce || design) { el.textContent = el.dataset.count; return; }
    function step(t){ if (!t0) t0 = t; var k = Math.min((t - t0) / dur, 1); k = 1 - Math.pow(1 - k, 3);
      el.textContent = (to * k).toFixed(dec).replace(/\B(?=(\d{3})+(?!\d))/g, ','); if (k < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }
  var cio = hasIO ? new IntersectionObserver(function(es){
    es.forEach(function(e){ if (e.isIntersecting) { count(e.target); cio.unobserve(e.target); } });
  }, {threshold: .6}) : null;

  /* autoplay videos only while visible */
  var vio = hasIO ? new IntersectionObserver(function(es){
    es.forEach(function(e){ var v = e.target;
      if (e.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      else v.pause();
    });
  }, {threshold: .15}) : null;

  /* before/after sliders */
  function cmp(c){
    var input = c.querySelector('input'); if (!input) return;
    function set(v){ c.style.setProperty('--pos', v + '%'); }
    input.addEventListener('input', function(){ c._touched = 1; set(input.value); });
    if (!hasIO || reduce) return;
    var o = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (!e.isIntersecting) return; o.disconnect();
        var t0 = null;
        function step(t){ if (c._touched) return; if (!t0) t0 = t; var k = Math.min((t - t0) / 2600, 1);
          var v = 50 + Math.sin(k * Math.PI * 2) * 28 * (1 - k); set(v.toFixed(2)); input.value = v; if (k < 1) requestAnimationFrame(step); }
        setTimeout(function(){ requestAnimationFrame(step); }, 400);
      });
    }, {threshold: .55});
    o.observe(c);
  }

  /* lighter video renditions fall back to the full file if missing */
  document.addEventListener('error', function(e){
    var s = e.target; if (!s || s.tagName !== 'SOURCE' || !s.dataset.full || s._fb) return; s._fb = 1;
    var v = s.parentNode; s.src = s.dataset.full; v.load(); if (!v.paused || v.hasAttribute('data-autoplay')) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
  }, true);

  function init(root){
    root = root || document;
    root.querySelectorAll('.tbx-rv:not(.in), .tbx-mask:not(.in), .rv-clip:not(.in), [data-rv]:not(.in)').forEach(function(el){
      if (!rio || design || reduce) el.classList.add('in'); else rio.observe(el);
    });
    root.querySelectorAll('[data-count]').forEach(function(el){ if (el._c) return; el._c = 1; if (cio) cio.observe(el); else el.textContent = el.dataset.count; });
    root.querySelectorAll('video[data-autoplay]').forEach(function(v){ if (v._a) return; v._a = 1; if (vio) vio.observe(v); else v.play(); });
    root.querySelectorAll('[data-tbx-cmp]').forEach(function(c){ if (c._c) return; c._c = 1; cmp(c); });
  }
  window.tbxInit = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); }); else init();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
